__turbopack_context__.v({
  "hidden": "styles-module-scss-module__ntrHGq__hidden",
  "shown": "styles-module-scss-module__ntrHGq__shown",
  "stickyCtaButtonAccent": "styles-module-scss-module__ntrHGq__stickyCtaButtonAccent",
  "stickyCtaButtonHolidayForest": "styles-module-scss-module__ntrHGq__stickyCtaButtonHolidayForest",
  "stickyCtaButtonHolidayGrapefruit": "styles-module-scss-module__ntrHGq__stickyCtaButtonHolidayGrapefruit",
  "stickyCtaButtonHolidaySnow": "styles-module-scss-module__ntrHGq__stickyCtaButtonHolidaySnow",
  "stickyCtaButtonStaple": "styles-module-scss-module__ntrHGq__stickyCtaButtonStaple",
  "stickyCtaButtonStatement": "styles-module-scss-module__ntrHGq__stickyCtaButtonStatement",
  "stickyCtaContainer": "styles-module-scss-module__ntrHGq__stickyCtaContainer",
});
